<template>
  <b-overlay :show="busy" rounded="sm">
    <b-card class="border-none py-0 mb-0 no-margin px-1">
      <b-card-body class="py-0">
        <div>
          <b-row>
            <b-col cols="12" sm="6" md="4" xl="3">
              <!-- <b-col cols="auto"> -->
              <b-form-group label-cols="12" label="Date" label-size="sm">
                <!-- :timePicker="true"
                      :timePicker24Hour="true" -->
                <b-input-group>
                  <daterangepicker
                    size="sm"
                    ref="date"
                    v-model="archive_at"
                    :opens="'right'"
                    :locale-data="locale_data"
                    :ranges="locale_ranges"
                    :showDropdowns="true"
                    :linkedCalendars="true"
                    :single-date-picker="'range'"
                  >
                  </daterangepicker>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="
                        date = {
                          startDate: null,
                          endDate: null,
                        }
                      "
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-left">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>
          <b-col class="text-right" cols="8">
            <b-button
              squared
              size="sm"
              variant="secondary"
              class="mr-1"
              @click="discard"
            >
              <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
            <b-button squared size="sm" variant="danger" @click="archiveit">
              <i class="fa fa-check"></i>
              Archive It
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-overlay>
</template>

<script>
export default {
  name: "Archive",
  data() {
    return {
      busy: false,
      archive_at: {
        startDate: this.$moment().startOf("month").format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
      },
      delete_it: true,
    };
  },
  methods: {
    archiveit() {
      console.log("local archiveit: ");
      this.$emit("archiveit", {
        archive_at: this.archive_at,
        delete_it: this.delete_it,
      });
    },
  },
};
</script>

<style>
</style>